const linkTags = ['a', 'nuxt-link', 'n-link', 'recess-link']

export default tag => {
  return linkTags.includes(tag)
}
